/* eslint-disable max-len */
import React, {
    useCallback,
    useEffect,
    useState,
    useContext
} from 'react';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import appConfig from 'app-config';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import { MLEndorsementFlowUtil, MLEndorsementUtil } from 'ml-portals-util-js';
import { MLNavigationStepsTrackingService, MLPortalStorageService } from 'ml-services-common-react';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import { useModal } from '@jutro/components';
import { FormModalPopover } from 'ml-components-platform-react';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
// eslint-disable-next-line import/no-unresolved
import metadata from './ProfileDetailsPagePolChange.metadata.json5';

import { Identify  } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';
import messages from './ProfileDetailsPagePolChange.messages';
import styles from './ProfileDetailsPagePolChange.module.scss';
import communicationPreferencePopupMetadata from './CommunicationPreferencePopup.metadata.json5';
import communicationPreferencePopupBodyStyles from './CommunicationPreferencePopup.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import { AccountService } from 'gw-capability-gateway-policy';
import { platformMessages } from 'ml-components-platform-react';
import MLEsignaturePolChangeComponent from '../../components/MLEsignaturePolChangeComponent/MLEsignaturePolChangeComponent';
import { MLProductCodeUtil } from 'ml-portals-util-js';
function ProfileDetailsPagePolChange(props) {
    const modalApi = useModal();
    const {
        wizardData,
        updateWizardData,
        goNext,
        currentStepIndex,
        steps,
        currentStep,
        changeNextSteps
    } = props;

    const [showErrors, updateShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { EndorsementService } = useDependencies('EndorsementService');
    const {
        onValidate,
        isComponentValid,
    } = useValidation('ProfileDetailsPagePolChange');
    
    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();
    
    const {
        addErrorAlert,
        clearAlerts,
        clearBlockAlerts,
        addWarningAlert
    } = MLNotificationBlockUtil();
    
    const ACCOUNT_DETAILS_PATH = 'baseData.policyContact_ML';
    const DRIVERS_PATH = 'lobData.personalAuto.coverables.drivers';
    const ML_STORAGE_KEY_ALREADY_VISITED = "USER_ALREADY_VISITED"
    
    const homePrimaryPhoneTypeCode = 'home';
    const workPrimaryPhoneTypeCode = 'work';
    const mobilePrimaryPhoneTypeCode = 'mobile';
    const primaryPhoneTypeValPath = 'baseData.policyContact_ML.primaryPhoneType.value';
    
    const { submissionVM } = wizardData;
    
    const [accountDetailsVM] = useState(_.get(submissionVM, ACCOUNT_DETAILS_PATH, {}));
    const driversVal = _.get(submissionVM, `${DRIVERS_PATH}.value`, {});
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);

    const isHomeOwners = submissionVM.value.isHomeOwners();
    const isPersonalAuto = submissionVM.value.isPersonalAuto();
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isGPA = appConfig.portalCode === 'GPA';

    const { authUserData } = useAuthentication();
    const { MLUserTypes } = appConfig;
    const isNonIAPolicy = !submissionVM.canEditCommunicationsFields_Ext.value
    const isEnableEsign_State= _.get(submissionVM,'baseData.enableEsign_State.value','')
    const userState = _.get(submissionVM, 'baseData.policyAddress.state.value.code','')
    const isEsignEnabledForState = isEnableEsign_State.split(',').map(state => state.trim()).includes(userState);
    const isModernProductPersonalAuto = isModernProduct && MLProductCodeUtil.isPersonalAuto(_.get(submissionVM, "baseData.productCode.value")); 
    
    let isEAorIA = false;
    if (authUserData) {
        isEAorIA = authUserData.userType === MLUserTypes.PCS || authUserData.userType === MLUserTypes.IA;
    }

    const retrieveFarmersPrivacyNoticeValue = () => {
        if(isPersonalAuto){
            return _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext');
        }else if(isPersonalUmbrella){
            return _.get(submissionVM, 'lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext');
        }else if(isHomeOwners){
            return _.get(submissionVM, 'lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext');
        }else 
            return undefined;
    }

    const [addtlPhoneNumbersVisible, updateAddtlPhoneNumbersVisible] = useState(false);
    const showSecondaryNamedInsuredEmail = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.value') !== undefined
    const showSpouseEmail = _.get(submissionVM, 'baseData.hasSpouse_ML.value') === true && isPersonalAuto
    const [hasSpouseEmailError, setSpouseEmailError] = useState(false);
    const [hasSecondaryEmailError, setSecondaryEmailError] = useState(false);
    const [communicationPreference, updateCommunicationPreference] = useState(_.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code'));
    const [initCommFieldValues, setInitCommFieldValues] = useState({});
    const [farmersPrivacyNoticeValue, setFarmersPrivacyNoticeValue] = useState(retrieveFarmersPrivacyNoticeValue());

    const alertsStatusUpdates = _.get(submissionVM, 'baseData.alertsStatusUpdatesCommPref_ML.value.code');
    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const isPhoneNumberValid = useCallback((phoneType) => {
        const isValid = _.get(submissionVM, `baseData.policyContact_ML.${phoneType}Number.value`)
            && _.get(submissionVM, `baseData.policyContact_ML.${phoneType}Number.aspects.valid`)
            && _.get(submissionVM, `baseData.policyContact_ML.${phoneType}Number.value.length`) === 10;
        return !!isValid;
    }, [submissionVM]);

    const [isHomePhonePrimary, updateIsHomePhonePrimary] = useState(false);
    const [isWorkPhonePrimary, updateIsWorkPhonePrimary] = useState(false);
    const [isCellPhonePrimary, updateIsCellPhonePrimary] = useState(false);
    const [profileUrl, updateProfileUrl] = useState(undefined);
    const [isUserAlreadyVisited, setIsUserAlreadyVisited] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getSpouseEmailPath = useCallback(() => {
        if (isPersonalAuto) {
            const index = driversVal.findIndex((drv) => drv.relationshipToInsured_ML === 'spouse');
            return `lobData.personalAuto.coverables.drivers.children.${index}.person.emailAddress_ML`;
        }
        return '';
    });

    const isInCO = () => {
        const addressVM = _.get(submissionVM, 'baseData.policyAddress');
        return addressVM.state.value && addressVM.state.value.code === 'CO';
    };

    const isInOR = () => {
        const addressVM = _.get(submissionVM, 'baseData.policyAddress');
        return addressVM.state.value && addressVM.state.value.code === 'OR';
    };

    const isInIA = () => {
        const addressVM = _.get(submissionVM, 'baseData.policyAddress');
        return addressVM.state.value && addressVM.state.value.code === 'IA';
    };

    const isInAL = () => {
        const addressVM = _.get(submissionVM, 'baseData.policyAddress');
        return addressVM.state.value && addressVM.state.value.code === 'AL';
    };

    const isInNV = () => {
        const addressVM = _.get(submissionVM, 'baseData.policyAddress');
        return addressVM.state.value && addressVM.state.value.code === 'NV';
    };

    const isSecondaryEmailRequired = () => {
        const value = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.policyBillingDocCommPref_ML.value.code');
        const hasSpouse = _.get(submissionVM, 'baseData.hasSpouse_ML.value') === true;
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value', []);
        const hasExcludedDriver =  drivers.some((driverVM) => {
            return driverVM.type_ML?.value?.code === 'excluded';
        })
        return isPersonalAuto && (isInAL() || isInIA || isInNV) && hasExcludedDriver && showSecondaryNamedInsuredEmail && isInOR() && (_.includes(['electronic', 'email'], value))
    };

    const isSpouseEmailRequired = () => {
        const value = _.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code');
        const hasSpouse = _.get(submissionVM, 'baseData.hasSpouse_ML.value') === true;
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value', []);
        const hasExcludedDriver =  drivers.some((driverVM) => {
            return driverVM.type_ML?.value?.code === 'excluded';
        })
        return isPersonalAuto && (((isInCO() || isInOR()) && hasSpouse) || (hasExcludedDriver && hasSpouse && isInOR() && (_.includes(['electronic', 'email'], value))))
    };

    const getNextStepText = () => {
        return (
            <FormattedMessage
                {...messages.nextBaseDescription}
                values={{
                    bold: (
                        <strong>{translator(messages.nextDescriptionBold)}</strong>
                    )
                }}
            />
        );
    };

    const showAdditionalPhoneNumbers = () => {
        updateAddtlPhoneNumbersVisible(true);
    };

    const getUpdateProfileUrl = () => {
        const promiseForUpdateProfileUrl = UsersProfileDetailsService.getUpdateProfileUrl(authHeader);

        promiseForUpdateProfileUrl.then((url) => {
            updateProfileUrl(url);
        });
    };

    const onChangeUsernameLinkClicked = () => {
        MLTagManagerService.sendLinkClickEvent(`AccountDetails_Update My Profile`);
        window.open(profileUrl, 'MsgWindow');
    };

    const policyContact_ML = _.get(submissionVM, 'baseData.policyContact_ML');

    const checkPhoneNumberEntered = useCallback(() => {
        return (_.isUndefined(policyContact_ML.cellNumber.value) &&
            _.isUndefined(policyContact_ML.homeNumber.value) &&
            _.isUndefined(policyContact_ML.workNumber.value));
    }, [policyContact_ML.cellNumber.value, policyContact_ML.homeNumber.value, policyContact_ML.workNumber.value]);

    const showPrimaryPhoneValidation = useCallback(() => {
        const primaryPhoneTypeValid = _.get(submissionVM, 'baseData.policyContact_ML.primaryPhoneType.aspects.valid');
        const primaryPhoneType = _.get(submissionVM, 'baseData.policyContact_ML.primaryPhoneType.value');
        return !primaryPhoneTypeValid || primaryPhoneType === undefined;
    }, [submissionVM]);

    const checkPhoneValidation = useCallback(() => {
        let hasError;
        const phoneNumEntered = checkPhoneNumberEntered();
        const primaryPhoneValidation = showPrimaryPhoneValidation();
        if (phoneNumEntered || primaryPhoneValidation) {
            hasError = true;
        } else {
            hasError = false;
        }
        return hasError;
    }, [checkPhoneNumberEntered, showPrimaryPhoneValidation]);

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const updatePhoneNumber = useCallback((phoneType, value, changedPath) => {
        if (changedPath) {
            if (value) {
                const unmaskedPhoneNumber = value.replace(/[^\d]/g, '');
                _.set(submissionVM, `${changedPath}.value`, unmaskedPhoneNumber);
            } else {
                _.set(submissionVM, `${changedPath}.value`, undefined);
            }
        }
        switch (phoneType) {
            case 'home':
                if (_.get(submissionVM, 'baseData.policyContact_ML.homeNumber.value') === '') {
                    _.set(submissionVM, 'baseData.policyContact_ML.homeNumber.value', undefined);
                }
                break;
            case 'cell':
                if (_.get(submissionVM, 'baseData.policyContact_ML.cellNumber.value') === '') {
                    _.set(submissionVM, 'baseData.policyContact_ML.cellNumber.value', undefined);
                }
                break;
            case 'work':
                if (_.get(submissionVM, 'baseData.policyContact_ML.workNumber.value') === '') {
                    _.set(submissionVM, 'baseData.policyContact_ML.workNumber.value', undefined);
                }
                break;
            default:
                break;
        }
        updateWizardSubmissionData(submissionVM);
    }, [submissionVM, updateWizardSubmissionData]);

    const syncPrimaryInsuredEmailWithDrivers = useCallback(() => {
        if (!isPersonalAuto || !_.get(submissionVM, 'lobData.personalAuto.coverables.drivers')) {
            return;
        }
        const policyContactDetails = _.get(submissionVM, ACCOUNT_DETAILS_PATH);
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value');
        if (drivers && drivers.length) {
            const primaryNamedDriver = drivers.find((driver) => driver.relationshipToInsured_ML === 'self');
            if (primaryNamedDriver && primaryNamedDriver.person) {
                primaryNamedDriver.person.emailAddress_ML = policyContactDetails.emailAddress1.value;
            }
        }
    }, [isPersonalAuto, submissionVM]);

    const syncPrimaryInsuredEmailWithVehicleOperators = useCallback(() => {
        if (!isPersonalUmbrella || !_.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicleOperators')) {
            return;
        }
        const policyContactDetails = _.get(submissionVM, ACCOUNT_DETAILS_PATH);
        const vehicleOperators = _.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicleOperators.value')
        if (vehicleOperators && vehicleOperators.length) {
            const primaryNamedVehicleOperator = vehicleOperators.find((vehOp) => vehOp.relationshipToInsured === 'self');
            if (primaryNamedVehicleOperator && primaryNamedVehicleOperator.contact) {
                primaryNamedVehicleOperator.emailAddress = policyContactDetails.emailAddress1.value;
            }
        }
    }, [isPersonalUmbrella, submissionVM]);

    const onEmailChanged = useCallback((type, value, changedPath) => {
        if (changedPath) {
            _.set(submissionVM, changedPath, value);
        }
        switch (type) {
            case 'secondary':
                if (hasSecondaryEmailError) {
                    setSecondaryEmailError(false);
                }
                break;
            case 'spouse':
                if (hasSpouseEmailError) {
                    setSpouseEmailError(false);
                }
                break;
            default:
                break;
        }
        updateWizardSubmissionData(submissionVM);
    }, [hasSpouseEmailError, updateWizardSubmissionData, submissionVM, hasSecondaryEmailError]);

    const loadInitialCommunicationFieldValues = () => {
        setInitCommFieldValues({
            primaryContactEmail: _.get(submissionVM, 'baseData.policyContact_ML.emailAddress1.value'),
            primaryContactHomePhone: _.get(submissionVM, 'baseData.policyContact_ML.homeNumber.value'),
            primaryContactWorkPhone: _.get(submissionVM, 'baseData.policyContact_ML.workNumber.value'),
            primaryContactCellPhone: _.get(submissionVM, 'baseData.policyContact_ML.cellNumber.value'),
            secondaryNamedInsuredEmail: _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.emailAddress1.value'),
            spouseEmail: _.get(submissionVM, `${getSpouseEmailPath()}.value`)
        });
    };

    const canEditCommField = (originalValue) => {
        return (isGPA && isNonIAPolicy && originalValue);
    };

    useEffect(() => {
        Identify('Endorsement Step Reached', {step: 'Communication Details Screen'}, submissionVM, authHeader)
        readPortalStorage();
    }, [])
    
    const readPortalStorage = async() => {
        console.log(submissionVM.jobID.value);  //logg
        let value = await MLPortalStorageService.retrieve(submissionVM.jobID.value, null, ML_STORAGE_KEY_ALREADY_VISITED, authHeader);
        
        try{
            let parsedResponse = JSON.parse(value);
            if (parsedResponse.hasOwnProperty('alreadyVisited') && parsedResponse.alreadyVisited === true) {
                setIsUserAlreadyVisited(JSON.parse(value).alreadyVisited);
            }
        }catch(e){
            console.log(e)
        }
    }

    const isMVRCacheQuestionEditable = () => {

        if(submissionVM.baseData.productCode.value === "PersonalAuto"){     //PA
            //this condition is checking when user already responded or we defaulted the value to false and user revisited the step
            if(isUserAlreadyVisited && (submissionVM.lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext !== undefined &&
            submissionVM.lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext !== null &&
            submissionVM.lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext === "false")){
                return false;
            }   //below condition is checking is the field response is empty or false and its the first time user visited in the step
            else if(!isUserAlreadyVisited && (submissionVM.lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext === undefined ||
            submissionVM.lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext === null ||
            submissionVM.lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext === "false")){
                return true;
            }else   //if user has responded to yes in NB transaction or in any previous transaction
                return false;
        }else if(submissionVM.baseData.productCode.value === "PersonalUmbrella"){       //PU
            if(isUserAlreadyVisited && ((submissionVM.lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext !== undefined &&
            submissionVM.lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext !== null  &&
            submissionVM.lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === "false"))){
                return false;
            }
            else if(!isUserAlreadyVisited && ((submissionVM.lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === undefined ||
            submissionVM.lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === null  ||
            submissionVM.lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === "false"))){
                return true;
            }else
                return false;
        }else if(submissionVM.baseData.productCode.value === "HOPHomeowners"){       //HO
            if(isUserAlreadyVisited && ((submissionVM.lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext !== undefined &&
            submissionVM.lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext !== null  &&
            submissionVM.lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === "false"))){
                return false;
            }
            else if(!isUserAlreadyVisited && ((submissionVM.lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === undefined ||
            submissionVM.lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === null  ||
            submissionVM.lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === "false"))){
                return true;
            }else
                return false;
        }
    }

    useEffect(() => {
        loadInitialCommunicationFieldValues();
        getUpdateProfileUrl();
        MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.updatedCommPreferences), false, currentStep.mlStepName, authHeader);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isGPA) {
            PolChangeTrackEvent('Endorsement Step Reached', false, submissionVM, authHeader, { step: 'PolChange Communications Preferences Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changePrimaryPhone = useCallback((primaryPhoneType, checked) => {
        let selectedPrimaryPhoneTypeCode;
        if (!checked) {
            selectedPrimaryPhoneTypeCode = undefined;
            _.set(submissionVM, primaryPhoneTypeValPath, undefined);
        } else {
            const primaryPhoneTypes = viewModelService.productMetadata.get('pc').types.getTypelist('PrimaryPhoneType');
            const selectedPrimaryPhoneType = primaryPhoneTypes.getCode(primaryPhoneType);
            _.set(submissionVM, primaryPhoneTypeValPath, selectedPrimaryPhoneType);

            selectedPrimaryPhoneTypeCode = selectedPrimaryPhoneType.code;
        }
        updateIsHomePhonePrimary(selectedPrimaryPhoneTypeCode === homePrimaryPhoneTypeCode);
        updateIsWorkPhonePrimary(selectedPrimaryPhoneTypeCode === workPrimaryPhoneTypeCode);
        updateIsCellPhonePrimary(selectedPrimaryPhoneTypeCode === mobilePrimaryPhoneTypeCode);
    }, [submissionVM, primaryPhoneTypeValPath, viewModelService.productMetadata]);

    const setDefaultPrimaryPhone = useCallback(() => {
        const homeNumber = _.get(submissionVM, 'baseData.policyContact_ML.homeNumber.value');
        const workNumber = _.get(submissionVM, 'baseData.policyContact_ML.workNumber.value');
        const cellNumber = _.get(submissionVM, 'baseData.policyContact_ML.cellNumber.value');

        if (homeNumber && (!workNumber && !cellNumber)) {
            changePrimaryPhone(homePrimaryPhoneTypeCode, true);
        } else if (workNumber && (!homeNumber && !cellNumber)) {
            changePrimaryPhone(workPrimaryPhoneTypeCode, true);
        } else if (cellNumber && (!workNumber && !homeNumber)) {
            changePrimaryPhone(mobilePrimaryPhoneTypeCode, true);
        }

        updateWizardSubmissionData(submissionVM);
    }, [changePrimaryPhone, submissionVM, updateWizardSubmissionData]);

    const showCommunicationPreferenceModal = useCallback((value, changedPath) => {
        if (changedPath) {
            if (value) {
                if (!isGPA && value === 'paper') {
                    const onContinue = () => {
                        updateCommunicationPreference(value);
                        MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Continue`);
                        return true;
                    };

                    const communicationPreferenceModalTitle = `${translator(messages.communicationPreferenceModalTitle)}`;

                    const componentProps = {
                        title: communicationPreferenceModalTitle,
                        uiProps: communicationPreferencePopupMetadata.pageContent,
                        actionBtnLabel: messages.communicationPreferenceModalContinue,
                        cancelBtnLabel: messages.communicationPreferenceModalCancel,
                        modalBodyStyles: communicationPreferencePopupBodyStyles,
                        onSaveAction: onContinue
                    };

                    modalApi.showModal(
                        <FormModalPopover {...componentProps} />
                    );
                } else {
                    updateCommunicationPreference(value);
                }
                _.set(submissionVM, changedPath, value);
            }
        }
        updateWizardSubmissionData(submissionVM)
    }, [updateWizardSubmissionData, submissionVM, isGPA, translator]);

    useEffect(() => {
        const primaryPhoneType = _.get(submissionVM, primaryPhoneTypeValPath);
        if (primaryPhoneType !== undefined) {
            if (_.get(submissionVM, 'baseData.policyContact_ML.cellNumber.value') || _.get(submissionVM, 'baseData.policyContact_ML.workNumber.value')) {
                updateAddtlPhoneNumbersVisible(true);
            }
            changePrimaryPhone(_.get(submissionVM, primaryPhoneTypeValPath).code, true);
        } else {
            changePrimaryPhone(undefined, false);
        }
    }, [submissionVM, primaryPhoneTypeValPath, changePrimaryPhone]);

    const showFarmersPrivacyNoticeValue = () => {
        return isPersonalAuto || isPersonalUmbrella || (isHomeOwners && isModernProduct);
    }

    const createPayloadToSyncQuestionSet = () => {
        var question;
        //populating false if user didnt ans the question
        var userResponse;
        if(farmersPrivacyNoticeValue === undefined || farmersPrivacyNoticeValue === null){
            userResponse = "false";
        }else{
            userResponse = farmersPrivacyNoticeValue;
        }
        if(isPersonalAuto){
            _.set(submissionVM, "lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext", userResponse)
            question = _.get(submissionVM, "lobData.personalAuto.questionSets_ML.value.privacyDisclaimer");
        }else if(isPersonalUmbrella){
            _.set(submissionVM, 'lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', userResponse);
            question = _.get(submissionVM, "lobData.personalUmbrella.value.privacyDisclaimer[0]");
        }else if(isHomeOwners){
            _.set(submissionVM, 'lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', userResponse);
            question = _.get(submissionVM, "lobData.homeowners.value.privacyDisclaimer[0]");
        }
        return question;
    }

    const syncQuestionSets = async () => {
        const aQuestionSetAnswersValue = createPayloadToSyncQuestionSet();
        const { code } = aQuestionSetAnswersValue;

        if (code && code === "PrivacyDisclaimer_ML") {

            try {
                showProgressDialog(platformMessages.syncingQuestions);
                
                const updatedQuestions = await EndorsementService.syncQuestionSetML(submissionVM.jobID.value, [aQuestionSetAnswersValue], authHeader);
                const transformedQuestions = {};

                updatedQuestions.forEach((q) => { transformedQuestions[q.code] = q; });

                if (isPersonalAuto) {
                    _.set(submissionVM, 'lobData.personalAuto.questionSets_ML.privacyDisclaimer.value', transformedQuestions.PrivacyDisclaimer_ML);
                }else if(isPersonalUmbrella){
                    _.set(submissionVM, 'lobData.personalUmbrella.value.privacyDisclaimer[0]', transformedQuestions.PrivacyDisclaimer_ML)
                }else if(isHomeOwners){
                    _.set(submissionVM, 'lobData.homeowners.value.privacyDisclaimer[0]', transformedQuestions.PrivacyDisclaimer_ML);
                }

            } finally {
                hideProgressDialog();
            }
        }
    };
     const hasPrimaryNamedInsuredEmail = () => {
        if (!isModernProductPersonalAuto || submissionVM.esignature_ML.esignatureOptions?.value?.code !== 'Email') {
            return true;
        }
        return (
         !(submissionVM.baseData.policyContact_ML.emailAddress1?.value===""||submissionVM.baseData.policyContact_ML.emailAddress1.value===undefined)
        );
    }
       const checkForEsign = () => {
           clearBlockAlerts("missingEsign");
           clearBlockAlerts("missingEsignOption");
           clearBlockAlerts("missingMobileNumber");
           clearBlockAlerts("missingEsignAck");
     
         if (!isModernProduct || !isEsignEnabledForState) return false;
     
           let missingInfo = false;
     
           const eSign = _.get(
             submissionVM,
             "esignature_ML.esign_Ext.value",
           );
     
           const eSignOption = _.get(
             submissionVM,
             "esignature_ML.esignatureOptions.value.code",
           );
     
           const mobile = _.get(
             submissionVM,
             "esignature_ML.mobileNumber_Ext.value",
           );
     
           // esign is mandatory
           if ((eSign === undefined || eSign === null)) {
             addErrorAlert(translator(messages.requiredFieldForEsign), 'missingEsign');
             missingInfo = true;
         }
     
           // eSignature Option is required when eSign = Yes
           
          else  if (eSign === true && !eSignOption) {
             addErrorAlert(
               translator(messages.requiredFieldForEsignOptions),
               "missingEsignOption",
             );
             missingInfo = true;
           }
     
           // Mobile is required when Text is selected
          else if (eSignOption === "Text" && !mobile) {
             addErrorAlert(
               translator(messages.requiredField),
               "missingMobileNumber",
             );
             missingInfo = true;
           }

           //Acknowledgement is required when Text is selected
           if (eSign === true && eSignOption === 'Text') {
               const esignAck = _.get(submissionVM, `esignature_ML.esignTextAck_Ext.value`);
               if (_.isUndefined(esignAck) || esignAck == undefined) {
                   addErrorAlert(
                       translator(messages.requiredFieldEsignAck),
                       "missingEsignAck",
                   );
                   missingInfo = true;
               }
           }
     
           return missingInfo;
         };

    const onNext = useCallback( async () => {
        clearAlerts();
         if(checkForEsign()){
            window.scrollTo(0, 0);
            return false;
        }
        if (isGPA) {
            setDefaultPrimaryPhone();
        }

        const primaryPhoneValidationError = checkPhoneValidation();
        if (primaryPhoneValidationError) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            addErrorAlert(messages.onePhoneMustBePrimary);
            return;
        };
         if (!hasPrimaryNamedInsuredEmail()) {
            addErrorAlert(translator(messages.missingpniEmail),"missingPrimaryEmail")      
            window.scrollTo(0, 0);
            return false;
        }

        const secondaryEmailError = isSecondaryEmailRequired();
        const secondaryEmail = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.emailAddress1.value');
        if (secondaryEmailError && secondaryEmail === undefined) {
            setSecondaryEmailError(true);
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return;
        };

        const spouseEmailError = isSpouseEmailRequired();
        const spouseEmail = _.get(submissionVM, getSpouseEmailPath());
        if (spouseEmailError && (!spouseEmail || spouseEmail.value === undefined || spouseEmail.value === '')) {
            setSpouseEmailError(true);
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return;
        };

        if (!(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return;
        }

        if(showFarmersPrivacyNoticeValue()){
            await syncQuestionSets();
            const jsonData = {  alreadyVisited: true };
            MLPortalStorageService.store(submissionVM.jobID.value, null, ML_STORAGE_KEY_ALREADY_VISITED, JSON.stringify(jsonData), authHeader);
        }

        syncPrimaryInsuredEmailWithDrivers();
        syncPrimaryInsuredEmailWithVehicleOperators();
        const lbl = MLEndorsementUtil.stepLabel(currentStep);
        MLEndorsementUtil.setEndorsementDescription(lbl, submissionVM, translator);
        const promise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        showProgressDialog(messages.savingPolicyChange, promise);
        promise.then((updatedPolicyChange) => {
            MLNavigationStepsTrackingService.setJobNumber(updatedPolicyChange.jobID);
            MLTagManagerService.sendFormStepPolicyChangeStep();
            const policyChange = new PolicyChange(Object.assign({}, updatedPolicyChange));
            const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
            MLNavigationStepsTrackingService.completeCurrentStep(null, authHeader);
            updateWizardSubmissionData(updatedEndorsementVM);
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep('endorsementAdditionalChanges', steps, currentStepIndex, changeNextSteps, goNext, productCode);
        });

        if (isGPA) {
            PolChangeTrackEvent('Endorsement Step Submitted', false, submissionVM, authHeader, {
                step: 'PolChange Communications Preferences Screen',
                action: 'Communications Preferences Submitted'
            });
        }

    }, [clearAlerts, isGPA, checkPhoneValidation, isSecondaryEmailRequired, submissionVM, isSpouseEmailRequired, getSpouseEmailPath,  translator, EndorsementService, authHeader, currentStep, showProgressDialog, setDefaultPrimaryPhone, errorTimestamp, addErrorAlert, viewModelService, updateWizardSubmissionData, steps, currentStepIndex, changeNextSteps, goNext, productCode]);

    const resolvers = {
        resolveComponentMap: {   
            mlEsignaturePolChangeComponent: MLEsignaturePolChangeComponent,                
        },
        resolveCallbackMap: {
            onNext: onNext
        },
        resolveClassNameMap: styles
    };

    const checkForTextAlerts = (value, path) => {
        if (value === 'text') {
            updateAddtlPhoneNumbersVisible(true);
        }
        _.set(submissionVM, path, value);
        updateWizardSubmissionData(submissionVM)
    };
    const emailTrim = ( event ) => {
        const emailAddress1 =  event.target.value;
        if(emailAddress1 == " "){
            event.target.value =""
        }
    }
    const validateEmailAddress = (accountContactDetailsVm) => {
        clearBlockAlerts("missingPrimaryEmail")
        const account = accountContactDetailsVm;
        let emailAddress1 =  _.get(account, 'emailAddress1.value');
        if(emailAddress1){
            emailAddress1 = emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(messages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(messages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification Api Called");
                if(res == true){
                    _.set(account, 'emailVerified_Ext.value', true);
                    _.set(account, 'emailAddress1.value', emailAddress1);
                }
                else{
                    _.set(account, 'emailVerified_Ext.value', false);
                    _.set(account, 'emailAddress1.value', emailAddress1 + " ");
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(messages.invalidEmail), 'invalidEmail');
                _.set(account, 'emailVerified_Ext.value', false);
                _.set(account, 'emailAddress1.value', emailAddress1);
                hideProgressDialog(messages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }
    };

    const emailOnBlur = useCallback((value, changedPath) => {
        const account = _.get(submissionVM,'baseData.policyContact_ML');
        validateEmailAddress(account);
    }, [validateEmailAddress]);

    const validateSpouseEmail = (account) => {
        let emailAddress1 =  _.get(account, 'person.emailAddress_ML');
        if(emailAddress1){
            emailAddress1 = emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(messages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(messages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification Api Called");
                if(res == true){
                    _.set(account, 'person.emailVerified_Ext', true);
                    _.set(account, 'person.emailAddress_ML', emailAddress1);
                }
                else{
                    _.set(account, 'person.emailVerified_Ext', false);
                    _.set(account, 'person.emailAddress_ML', emailAddress1 + " ");
                    updateShowErrors(true);
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(messages.invalidEmail), 'invalidEmail');
                _.set(account, 'person.emailVerified_Ext', false);
                _.set(account, 'person.emailAddress_ML', emailAddress1);
                hideProgressDialog(messages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }
    };

    const handleSpouseOnBlur = () => {
        const account  = _.get(submissionVM, "value.lobData");
        const state = submissionVM.baseData.policyAddress.state.value.code;
        if(account.personalAuto && _.includes(["OR", "CO"], state)){
            const spouse = account.personalAuto.coverables.drivers.map((driver) => {
                if(driver.relationshipToInsured_ML === 'spouse')
                    return driver
            }).filter(Boolean); 
            validateSpouseEmail(spouse[0])
        }
    }

    const trimSpouseEmail = ( spouseVM, event ) => {
        let email = _.get(spouseVM, 'person.emailAddress_ML');
        if( email !== "" && email !== undefined){
            email = email.trim();
            _.set(spouseVM, 'person.emailAddress_ML', email);
        }
        let eventEmail = event.target.value;
        if(eventEmail !== "" && eventEmail !== undefined){
            eventEmail = eventEmail.trim();
            event.target.value = eventEmail;
        }
    }

    const handleSpouseOnFocus = ( event ) => {
        const account  = _.get(submissionVM, "value.lobData");
        if(account.personalAuto){
            const spouse = account.personalAuto.coverables.drivers.map((driver) => {
                if(driver.relationshipToInsured_ML === 'spouse')
                    return driver
            }).filter(Boolean); 
            trimSpouseEmail(spouse[0], event)
        }
    }

    const handleSecondaryInsuredEmailOnBlur = ( changedPath ) => {
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value');
        const hasExcludedDriver =  drivers.some((driverVM) => {
            return driverVM.type_ML.value.code === 'excluded';
        })
        const isComPrefElectronicOrEmail = _.includes(["electronic", "email"], _.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code'))
        const isORstate = _.includes(["OR"], state)

        if(!hasExcludedDriver || !showSecondaryNamedInsuredEmail || !isComPrefElectronicOrEmail || !isORstate) {
            return false
        }
        let emailAddress1 =  _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.emailAddress1.value');
        if(emailAddress1){
            emailAddress1 = emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(messages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(messages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification Api Called");
                if(res == true){
                    _.set(submissionVM, 'baseData.secondaryNamedInsured_ML.emailVerified_Ext', true);
                    _.set(submissionVM, 'baseData.secondaryNamedInsured_ML.emailAddress1.value', emailAddress1);
                }
                else{
                    _.set(submissionVM, 'baseData.secondaryNamedInsured_ML.emailVerified_Ext', false);
                    _.set(submissionVM, 'baseData.secondaryNamedInsured_ML.emailAddress1.value', emailAddress1 + " ");
                    updateShowErrors(true);
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(messages.invalidEmail), 'invalidEmail');
                _.set(submissionVM, 'baseData.secondaryNamedInsured_ML.emailVerified_Ext', false);
                _.set(submissionVM, 'baseData.secondaryNamedInsured_ML.emailAddress1.value', emailAddress1);
                hideProgressDialog(messages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }
    }

    const handleSecondaryInsuredEmailOnFocus = ( event ) => {
        let email =  _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.emailAddress1.value');
        if(email !== "" && email !== undefined){
            email = email.trim();
            _.set(submissionVM, 'baseData.secondaryNamedInsured_ML.emailAddress1.value', email);
        }

        let eventEmail = event.target.value;
        if(eventEmail !== "" && eventEmail !== undefined){
            eventEmail = eventEmail.trim();
            event.target.value = eventEmail;
        }
    }

    const updateFarmersPrivacyUserResponse = (value, path) => {
        setFarmersPrivacyNoticeValue( value?"true":"false" );
        _.set(submissionVM, path, value);
        updateWizardSubmissionData(submissionVM)
    }

    const override = {
        pageContainer: {
            className: isGPA ? 'page-content-gpa' : ''
        },
        stickyContinueSection: {
            visible: isGPA,
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(),
            onNext
        },
        nextDescription: {
            content: getNextStepText()
        },
        homePhoneNumber: {
            onValueChange: (value, changedPath) => updatePhoneNumber('home', value, changedPath),
            disabled: canEditCommField(initCommFieldValues.primaryContactHomePhone)
        },
        emailAddress: {
            onValueChange: (value, changedPath) => onEmailChanged('primary', value, changedPath),
            disabled: canEditCommField(initCommFieldValues.primaryContactEmail) || !!initCommFieldValues.primaryContactEmail,
            onBlur : emailOnBlur,
            onFocus: (event) => emailTrim( event )
        },
        homePhonePrimaryCheckbox: {
            value: isHomePhonePrimary,
            onValueChange: (value) => changePrimaryPhone(homePrimaryPhoneTypeCode, value)
        },
        additionalPhoneNumberLinkContainer: {
            visible: !addtlPhoneNumbersVisible
        },
        additionalPhoneNumbersLink: {
            onClick: showAdditionalPhoneNumbers
        },
        additionalPhoneNumbersContainer: {
            visible: addtlPhoneNumbersVisible
        },
        workPhoneNumber: {
            onValueChange: (value, changedPath) => updatePhoneNumber('work', value, changedPath),
            disabled: canEditCommField(initCommFieldValues.primaryContactWorkPhone)
        },
        workPhonePrimaryCheckbox: {
            value: isWorkPhonePrimary,
            onValueChange: (value) => changePrimaryPhone(workPrimaryPhoneTypeCode, value)
        },
        cellPhoneNumber: {
            onValueChange: (value, changedPath) => updatePhoneNumber('cell', value, changedPath),
            disabled: canEditCommField(initCommFieldValues.primaryContactCellPhone)
        },
        cellPhonePrimaryCheckbox: {
            value: isCellPhonePrimary,
            onValueChange: (value) => changePrimaryPhone(mobilePrimaryPhoneTypeCode, value)
        },
        spouseEmailAddressContainer: {
            visible: showSpouseEmail
        },
        spouseEmailAddress: {
            path: getSpouseEmailPath(),
            onValueChange: (value, changedPath) => onEmailChanged('spouse', value, changedPath),
            disabled: canEditCommField(initCommFieldValues.spouseEmail),
            onBlur: handleSpouseOnBlur,
            onFocus: (event) => handleSpouseOnFocus(event),
        },
        secondaryNamedInsuredEmailAddressContainer: {
            visible: showSecondaryNamedInsuredEmail
        },
        secondaryNamedInsuredEmailAddress: {
            visible: showSecondaryNamedInsuredEmail,
            onValueChange: (value, changedPath) => onEmailChanged('secondary', value, changedPath),
            disabled: canEditCommField(initCommFieldValues.secondaryNamedInsuredEmail),
            onBlur: handleSecondaryInsuredEmailOnBlur,
            onFocus: (event) => handleSecondaryInsuredEmailOnFocus(event),
        },
        communicationPreferenceRadioButton: {
            value: communicationPreference,
            onValueChange: (value, changedPath) => showCommunicationPreferenceModal(value, changedPath)
        },
        alertsStatusUpdatesRadioButton: {
            value: alertsStatusUpdates,
            onValueChange: (value, changedPath) => checkForTextAlerts(value, changedPath)
        },
        privacyDisclaimerContainer: {
            visible: showFarmersPrivacyNoticeValue()
        },
        privacyDisclaimerRadioButton: {
            value: farmersPrivacyNoticeValue,
            visible: showFarmersPrivacyNoticeValue(),
            disabled: !isMVRCacheQuestionEditable(),
            onValueChange: (value, changedPath) => updateFarmersPrivacyUserResponse(value, changedPath)
        },
        updateUsernameLinkContainer: {
            visible: !isGPA
        },
        updateUsernameLink: {
            visible: !isGPA,
            onClick: onChangeUsernameLinkClicked
        },
        esignContainer: {
        visible: isModernProduct && isEsignEnabledForState,
        model: submissionVM,
        updateWizardData: updateWizardSubmissionData
}
    };

    if (hasSpouseEmailError) {
        override.spouseEmailAddress.showErrors = true;
        override.spouseEmailAddress.validationMessages = [];
        override.spouseEmailAddress.validationMessages.push(translator(messages.thisIsARequiredField));
    }
    if (hasSecondaryEmailError) {
        override.secondaryNamedInsuredEmailAddress.showErrors = true;
        override.secondaryNamedInsuredEmailAddress.validationMessages = [];
        override.secondaryNamedInsuredEmailAddress.validationMessages.push(translator(messages.thisIsARequiredField));
    }

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            policyChangePageHeaderML={messages.profileDetails}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={override}
                model={submissionVM}
                componentMap={resolvers.resolveComponentMap}
                onModelChange={updateWizardSubmissionData}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

ProfileDetailsPagePolChange.propTypes = wizardProps;
export default withAuthenticationContext(ProfileDetailsPagePolChange);
